import { TemplateRef } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import * as _ from 'lodash';
import { MODAL_CONFIG } from '../../../services/constant';
import { TranslateService } from '@ngx-translate/core';
var ProductListDetailComponent = (function () {
    function ProductListDetailComponent(apiService, modalService, translate) {
        this.apiService = apiService;
        this.modalService = modalService;
        this.translate = translate;
        this.product = {};
        this.groups = [];
        this.companyGroupID = [];
        this.title = '';
        this.createMode = false;
        this.errorMessage = null;
        this.errorMsgForShow = null;
        this.errorMsgForShows = null;
        this.parent = null;
        this.checkUser = false;
    }
    ProductListDetailComponent.prototype.open = function (parent, selectedUser) {
        this.parent = parent;
        this.errorMessage = null;
        if (selectedUser != null) {
            this.product = _.cloneDeep(selectedUser);
            this.createMode = false;
            this.companyGroupID = [];
            this.checkUser = true;
            this.title = this.translate.instant('PRODUCT.LIST.MODAL.TITLE') + ' : ' + this.product.display;
        }
        else {
            this.product = { 'product_id': '', 'name_en': '', 'name_th': '', 'vat': '' };
            this.createMode = true;
            this.checkUser = false;
            this.title = this.translate.instant('PRODUCT.LIST.MODAL.ADD-USER');
        }
        this.modalRef = this.modalService.show(this.modalTemplate, MODAL_CONFIG);
    };
    ProductListDetailComponent.prototype.ngOnInit = function () {
    };
    ProductListDetailComponent.prototype.submit = function () {
        var _this = this;
        if (this.translate.currentLang !== 'en') {
            var errorField = [];
            this.errorMessage = null;
            if (this.product.product_id == null || this.product.product_id.length === 0) {
                errorField.push('รหัสผลิตภัณฑ์');
            }
            if (this.createMode && (this.product.name_en == null || this.product.name_en.length === 0)) {
                errorField.push('ชื่อผลิตภัณฑ์');
            }
            if (errorField.length > 0) {
                this.errorMessage = 'โปรดกรอก ' + errorField.join(', ') + ' ให้ถูกต้อง';
                return;
            }
        }
        else {
            var errorField = [];
            this.errorMessage = null;
            if (this.product.product_id == null || this.product.product_id.length === 0) {
                errorField.push('Product ID');
            }
            if (this.createMode && (this.product.name_en == null || this.product.name_en.length === 0)) {
                errorField.push('Product name');
            }
            if (errorField.length > 0) {
                this.errorMessage = 'Please fill ' + errorField.join(', ') + ' correctly';
                return;
            }
        }
        var request = null;
        if (this.createMode) {
            this.product.name_th = this.product.name_en;
            var vat = this.product.vat.replace(/,/g, '');
            if (vat) {
                this.product.vat = parseFloat(vat);
            }
            request = this.apiService.createProduct(this.product);
        }
        else {
            this.product.name_th = this.product.name_en;
            var vat = this.product.vat.replace(/,/g, '');
            if (vat) {
                this.product.vat = parseFloat(vat);
            }
            request = this.apiService.updateProduct(this.product.id, this.product);
        }
        request.subscribe(function (obj) {
            if (_this.createMode) {
                _this.sniff('CREATE_PRODUCT', _this.product.product_id + ':' + _this.product.name_en + _this.product.name_th + ':' + _this.product.vat);
            }
            else {
                _this.sniff('UPDATE_PRODUCT', _this.product.product_id + ':' + _this.product.name_en + _this.product.name_th + ':' + _this.product.vat);
            }
            _this.parent.reload();
            _this.modalRef.hide();
            _this.clearData();
        }, function (error) {
            console.log(error);
            _this.checkErrorMsg(error);
        });
    };
    ProductListDetailComponent.prototype.checkErrorMsg = function (error) {
        this.errorMessage = this.apiService.getErrorMessage(error);
    };
    ProductListDetailComponent.prototype.clearData = function () {
        this.product = {};
        this.companyGroupID = null;
        this.errorMsgForShow = null;
    };
    ProductListDetailComponent.prototype.close = function () {
        this.modalRef.hide();
        this.clearData();
    };
    ProductListDetailComponent.prototype.sniff = function (action, target) {
        var data = {
            action: action,
            address: 'MANAGE_PRODUCT',
            target: target
        };
        this.apiService.sniff(data).subscribe(function (res) {
        });
    };
    return ProductListDetailComponent;
}());
export { ProductListDetailComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/product/product-list-detail/product-list-detail.component.ts.pre-build-optimizer.js